"use client"

import React, { useState, useEffect } from "react"
import Image from "next/image"
import { RevealOnScroll } from "@/components/reveal-on-scroll"

const slides = [
  {
    src: "/images/1.webp",
    alt: "WELCOME TO LOKBHARATI GROUP OF SCHOOLS & COLLEGES"
  },
  {
    src: "/images/2.webp",
    alt: "LOKBHARATI GROUP OF SCHOOLS & COLLEGES students"
  },
  {
    src: "/images/3.webp",
    alt: "LOKBHARATI GROUP OF SCHOOLS & COLLEGES facilities"
  },
  {
    src: "/images/4.webp",
    alt: "LOKBHARATI GROUP OF SCHOOLS & COLLEGES facilities"
  }
]

export function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length)
    }, 5000) // Change slide every 5 seconds

    return () => clearInterval(timer)
  }, [])

  const goToSlide = (index: number) => {
    setCurrentSlide(index)
  }

  return (
    <section id="home" className="relative h-[600px] flex items-center justify-center bg-white">
      {/* Background image slider */}
      <div className="absolute inset-0">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? "opacity-100" : "opacity-0"
              }`}
          >
            <Image
              src={slide.src}
              alt={slide.alt}
              fill
              priority={index === 0}
              className="object-cover"
            />
          </div>
        ))}
        {/* dark overlay for readability */}
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Centered welcome text (over image) */}
      <div className="relative z-10 px-4 text-center overflow-hidden">
        <RevealOnScroll animationClass="animate-slide-in-left">
          <h1 className="font-extrabold tracking-tight leading-tight text-white text-3xl sm:text-4xl lg:text-5xl">
            Welcome to LOKBHARATI GROUP OF SCHOOLS & COLLEGES
          </h1>
        </RevealOnScroll>

        <RevealOnScroll animationClass="animate-slide-in-right delay-300">
          <p className="mt-3 text-white/90 text-sm sm:text-base lg:text-lg">
            Inspiring excellence, character, and lifelong learning.
          </p>
        </RevealOnScroll>
      </div>

      {/* Slider indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all ${index === currentSlide
              ? "bg-white w-8"
              : "bg-white/50 hover:bg-white/75"
              }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  )
}